import { getRequestHeader } from "h3";
import { toBcp47Locale } from "@backmarket/utils/string/toBcp47Locale";
export function getLocaleFromAcceptLanguage(event) {
  const acceptLanguageHeader = getRequestHeader(event, "Accept-Language");
  if (!acceptLanguageHeader) return null;
  try {
    return toBcp47Locale(acceptLanguageHeader);
  } catch {
    return null;
  }
}
